export enum HistoryTypes {
    AUDIT_TRAIL = 'audit-trail',
    COMMENTS = 'comments'
}
